<template>
    <div>
        <!-- Bottom Navigation -->
        <nav class="theme2-bottom-nav">
            <div class="theme2-bottom-nav-container">
                <button class="theme2-bottom-nav-item" :class="{'theme2-active': currentRoute === 'Kids Devices'}" @click="navigateAndClose('/kids-device')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                    </svg>
                    <span class="theme2-bottom-nav-label">Dashboard</span>
                </button>
                
                <button class="theme2-bottom-nav-item" :class="{'theme2-active': currentRoute === 'Applications List' || currentRoute === 'Application'}" @click="navigateAndClose('/play-store')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                    </svg>
                    <span class="theme2-bottom-nav-label">Apps</span>
                </button>
                
                <button class="theme2-bottom-nav-item" :class="{'theme2-active': currentRoute === 'requests'}" @click="navigateAndClose('/requests')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                    </svg>
                    <span class="theme2-bottom-nav-label">Requests</span>
                    <span v-if="requestCount > 0" class="theme2-bottom-nav-badge">{{ requestCount }}</span>
                </button>
                
                <button class="theme2-bottom-nav-item" :class="{'theme2-active': currentRoute === 'more'}" @click="$emit('toggle-sidebar')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                    </svg>
                    <span class="theme2-bottom-nav-label">More</span>
                </button>
            </div>
        </nav>

        <!-- Footer Section -->
        <footer class="theme2-footer" v-if="currentRoute != 'contact'">
            <div class="theme2-footer-container">
                <div class="theme2-help-section">
                    <h4 class="theme2-help-title">
                        <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                        </svg>
                        Need Help?
                    </h4>
                    <div class="theme2-help-links">
                        <p><strong>Email:</strong> <a href="mailto:support@mywingio.com">support@mywingio.com</a></p>
                        <p><strong>Phone:</strong> <a href="tel:+447349970810">+44 7349 970810</a></p>
                        <p>
                            <strong>Parent APP - Guide:</strong><br>
                            <a href="https://www.mywingio.com/how-it-works" target="_blank" rel="noopener noreferrer">
                                https://www.mywingio.com/how-it-works
                            </a>
                        </p>
                        <p>
                            <strong>Kids APP - Guide:</strong><br>
                            <a href="https://www.mywingio.com/wingio-child-app" target="_blank" rel="noopener noreferrer">
                                https://www.mywingio.com/wingio-child-app
                            </a>
                        </p>
                    </div>
                </div>

                <hr class="theme2-footer-divider">
                
                <p class="theme2-copyright">Wingio 2025. All rights reserved</p>
                
                <div class="theme2-footer-links">
                    <a href="https://www.mywingio.com/privacy" target="_blank">Privacy Policy</a>
                    <span>•</span>
                    <a href="https://www.mywingio.com/terms-conditions" target="_blank">Terms & Conditions</a>
                    <span>•</span>
                    <a href="https://www.mywingio.com/returns" target="_blank">Shipping & Returns</a>
                    <span>•</span>
                    <a href="https://www.mywingio.com/warranty" target="_blank">Warranty</a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'KidFooter2',
    props: {
        profileId: String,
        serialNumber: String,
        requestCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            currentRoute: this.$route.name,
        }
    },
    methods: {
        navigateTo(path) {
            this.$router.push({ 
                path: path, 
                query: { 
                    profileId: this.profileId, 
                    serialNumber: this.serialNumber 
                } 
            });
        },
        navigateAndClose(path) {
            this.navigateTo(path);
        }
    },
    watch: {
        '$route.name'(newName) {
            this.currentRoute = newName;
        }
    }
}
</script>

<style scoped>
@import '../../assets/theme2.css';
</style>